module.exports = __webpack_public_path__ + "static/media/smile-squint-wink.8ddcb7ad.svg";